import {Component, OnInit, OnDestroy} from '@angular/core';
import {Response} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Rx';
import {EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService} from 'ng-jhipster';

import {EntityAuditEvent} from './entity-audit-event.model';
import {EntityAuditEventService} from './entity-audit-event.service';
import {ITEMS_PER_PAGE, Principal} from '../../shared';
import {CandidatureFormationService} from "../candidature/candidature-formation.service";
import {CandidatureFormation} from "../candidature/candidature-formation.model";

@Component({
    selector: 'jhi-entity-audit-event',
    templateUrl: './entity-audit-event.component.html'
})
export class EntityAuditEventComponent implements OnInit, OnDestroy {

    currentAccount: any;
    entityAuditEvents: EntityAuditEvent[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    candidatureFormationId: number;
    valueDialog = false;
    entityValue: string;
    private subscription: any;
    isLoading: boolean = false;
    isFilterCandidatureDisplayed = true;
    private candidatureFormation: CandidatureFormation=null;

    constructor(private jhiLanguageService: JhiLanguageService,
                private entityAuditEventService: EntityAuditEventService,
                private parseLinks: ParseLinks,
                private alertService: AlertService,
                private principal: Principal,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private eventManager: EventManager,
                private candidatureFormationService: CandidatureFormationService,
                private route: ActivatedRoute) {
        this.itemsPerPage = 300 ;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['entityAuditEvent']);
        this.subscription = this.route.params.subscribe(params => {
            this.candidatureFormationId = params['id'];
            if (this.candidatureFormationId != null) {
                this.isFilterCandidatureDisplayed = false;
                this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(candidatureFormation => {
                    if (candidatureFormation != null) {
                        this.candidatureFormation=candidatureFormation ;
                    }
                });

            }
        });
    }

    loadAll() {
        this.entityAuditEvents = null;
        this.isLoading = true;
        if (this.candidatureFormationId!=null && this.isLoading ) {
            this.entityAuditEventService.findLogCandidatureFormation(this.candidatureFormationId).subscribe(
                (res: Response) => this.onSuccess(res.json(), null),
                (res: Response) => this.onError(res.json())
            );
        } else {
            this.entityAuditEventService.query({
                page: this.page - 1,
                size: this.itemsPerPage,
                query: this.candidatureFormationId,
                sort: this.sort()
            }).subscribe(
                (res: Response) => this.onSuccess(res.json(), res.headers),
                (res: Response) => this.onError(res.json())
            );
        }
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.candidatureFormationId != null) {
            this.router.navigate(['/entity-audit-event/candidatureFormation/' + this.candidatureFormationId], {
                queryParams:
                    {
                        page: this.page,
                        size: this.itemsPerPage,
                        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                    }
            });
        } else {
            this.router.navigate(['/entity-audit-event'], {
                queryParams:
                    {
                        page: this.page,
                        size: this.itemsPerPage,
                        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                    }
            });
        }
        this.loadAll();
    }

    clear() {
        this.page = 0;
        this.router.navigate(['/entity-audit-event', {
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }]);
        this.loadAll();
    }

    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInEntityAuditEvents();
    }

    viewValue(value) {
        this.entityValue = JSON.stringify(JSON.parse(value.replace(/,/g, ', ')), null, 4);
        this.valueDialog = true;
    }

    closeValueDialog() {
        this.valueDialog = false;
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: EntityAuditEvent) {
        return item.id;
    }

    registerChangeInEntityAuditEvents() {
        this.eventSubscriber = this.eventManager.subscribe('entityAuditEventListModification', (response) => this.loadAll());
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private onSuccess(data, headers) {
        this.isLoading = false;
        if ( headers!=null) {
            this.links = this.parseLinks.parse(headers.get('link'));
            this.totalItems = headers.get('X-Total-Count');
            this.queryCount = this.totalItems;
        }
        // this.page = pagingParams.page;
        this.entityAuditEvents = data;
    }

    private onError(error) {
        this.isLoading = false;
        this.alertService.error(error.message, null, null);
    }

    private goToCandidature() {
        this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(candidatureFormation => {
            if (candidatureFormation != null) {
                if (candidatureFormation.reinscription) {
                    this.router.navigate(['/reinscription/' + candidatureFormation.id]);
                } else {
                    this.router.navigate(['/candidature/' + candidatureFormation.id]);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/entity-audit-event.component.ts